<div class="general-info u-margin-top-20" *ngIf="config">
  <div class="general-info__title-label o-flex o-flex--align-items-center" [ngClass]="{'o-flex--justify-space-between': isPaymentView}">
    <span class="general-info--font-size-35 u-font-weight u-right-padding-5" [ngClass]="{'u-font-size-20 line-height-24': isPaymentView}">{{config.title}}</span>
    <div class="o-flex o-flex--align-items-center">
      <app-label class="u-right-padding-5" *ngFor="let label of config.tags" [text]="label" [isRecommended]="config.isRecommended" [labelHeight]="config.labelHeight" [isBeta]="isBeta()"></app-label>
    </div>
  </div>
  <app-unordered-list [listItem]="config.marketingFeatures"></app-unordered-list>
</div>
